import { render, staticRenderFns } from "./headbar.vue?vue&type=template&id=70ef2fea&scoped=true&"
import script from "./headbar.vue?vue&type=script&lang=js&"
export * from "./headbar.vue?vue&type=script&lang=js&"
import style0 from "./headbar.vue?vue&type=style&index=0&id=70ef2fea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ef2fea",
  null
  
)

export default component.exports